<template>
  <div class="my-account-login">
    <consent-dialog-fi
      ref="consentDialog"
      :fields="fields"
      @confirm="redirectTo(successRedirect)"
    />

    <site-login-standalone @logged-in="loggedInStandalone" />
  </div>
</template>

<script>
import ConsentDialogFi from 'components/my-account/site-login/consent-dialog-fi/ConsentDialogFi';
import SiteLoginStandalone from 'components/my-account/site-login/SiteLoginStandalone';
import GIVECONSENT from 'gql/giveConsent.gql';
import consentMixin from 'mixins/consentMixin';

export default {
  name: 'MyAccountLogin',
  components: {
    ConsentDialogFi,
    SiteLoginStandalone,
  },
  mixins: [consentMixin],
  inject: ['fields'],
  async created() {
    if (IS_SSR) {
      return;
    }

    // login will fail (CORS policy) if we are on an unsecure connection
    if (window.location.protocol !== 'https:' && !IS_SHOWROOM) {
      window.location.replace(
        `https:${window.location.href.substring(window.location.protocol.length)}`,
      );
    }
  },
  methods: {
    async loggedInStandalone(el) {
      const newConsent = await this.checkNewConsents(el.accessToken);
      let { redirect } = el;
      const separator = redirect.includes('#') ? '&' : '#';
      if (el.data) {
        redirect = `${redirect}${separator}${el.data}&logged-in=true`;
      } else {
        redirect = `${redirect}${separator}logged-in=true`;
      }

      if (newConsent) {
        this.successRedirect = redirect;
      } else {
        this.redirectTo(redirect);
      }
    },
    async checkNewConsents(accessToken) {
      if (!this.fields.enableConsentDialog?.value) {
        return false;
      }

      try {
        const userConsentTemplates = await this.getConsentTemplates(accessToken);
        const registrationConsents = userConsentTemplates.filter(
          (consent) =>
            consent.id === `REGISTRATION_DATA_PRIVACY_${this.$fischer.baseSiteId()}` ||
            consent.id === `REGISTRATION_TERMS_AND_CONDITIONS_${this.$fischer.baseSiteId()}`,
        );

        let newConsent = false;
        registrationConsents.forEach((consent) => {
          if (!consent.currentConsent) {
            newConsent = true;
            this.newConsentTemplates.push({ id: consent.id, version: consent.version });
          }
        });

        if (newConsent) {
          this.$refs.consentDialog.open();
          this.acceptConsent(accessToken);
        }

        return newConsent;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async acceptConsent(accessToken) {
      await this.newConsentTemplates.forEach(async (consentTemplate) => {
        await this.$apollo.mutate({
          mutation: GIVECONSENT,
          variables: {
            baseSiteId: this.$fischer.baseSiteId(),
            accessToken,
            userId: 'current',
            consentTemplateId: consentTemplate.id,
            consentTemplateVersion: consentTemplate.version,
            lang: this.$fischer.language_639_1(),
          },
        });
      });
    },
    redirectTo(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './my-account-login';
</style>
